import React, { useContext, useState } from "react";
import Modal from "react-modal";
import { LogoP } from "../../assets/svgs/LogoP";
import ButtonToogle from "../../components/ButtonTootle";
import IconClose from "../../assets/images/icon-close.png";
import { constants } from "../../constants/SectionHomeReponsive";
import "./style.scss";

import { AppContext } from "../../store";

export default function SectionHomeReponsive() {
  const { state, openPromotion } = useContext(AppContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const showModalTerm = () => {
    document.body.style.overflow = "hidden";
    setModalIsOpen(!modalIsOpen);
  };

  const closeModalTerm = () => {
    document.body.style.overflow = "auto";
    setModalIsOpen(false);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)"
    }
  };

  return (
    <>
      <section className="section-home-container blue">
        <div className="f32 bold text-initial mb15">
          {state.mainBonus} mensalidades grátis para Cliente PAN.
        </div>
        <div className="f12 text-initial">
          Cliente PAN aproveita o benefício! Escolha seu plano usando seu cartão PAN.
        </div>
      </section>

      <section className="section-home-container text-center">
        <div className="container-text">
          <div className="logo-banco-pan">
            <LogoP />
          </div>
          <span className="tc">
            Conheça os planos e as vantagens que preparamos para você, Cliente
            PAN:
          </span>
        </div>
      </section>
      <section className="infomations">
        <ButtonToogle
          information={constants[0]}
          openModal={showModalTerm}
          promotion={openPromotion("PRE")}
        />
        <ButtonToogle
          information={constants[1]}
          openModal={showModalTerm}
          promotion={openPromotion("POS")}
        />
        <div className="validate">*Oferta válida até {state.regulamento.validity}</div>
      </section>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModalTerm}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="modal">
					<div className="modal-header">
						<button className="btn-close" onClick={closeModalTerm}>
							<img alt="Icon Close" src={IconClose} />
						</button>
					</div>
					<div className="title" style={{ textAlign: 'center', marginTop: 30 }}>
						<h4>{state.regulamento.title.toUpperCase()}</h4>
					</div>
					<div className="modal-container calibri" dangerouslySetInnerHTML={{__html: state.regulamento.content}} />
				</div>
      </Modal>
    </>
  );
}
